import React, { FC, useEffect } from 'react';
import translate from '@translate';
import { useDispatch, useSelector } from 'react-redux';
import { setLocationParams } from 'src/resources/location/reducer';
import {
    getTransportPackageTypesListFetch,
    syncCatalogueTransportPackageTypesFetch,
    syncTransportPackageTypesFetch,
} from 'src/resources/transportPackageTypesList/reducer';
import { RootStoreType } from 'src/types/store';
import TableSimple from 'src/components/TableSimple';
import { allColumns } from './constants';
import TopBlock from './TopBlock';
import { useCheckPermission } from 'src/utils/checkPermission';
import StoreIcon from '@mui/icons-material/Store';

const TransportPackageTypesListContainer: FC = () => {
    const dispatch = useDispatch();

    const loading = useSelector((state: RootStoreType) => state.transportPackageTypesList.loading);
    const rows = useSelector((state: RootStoreType) => state.transportPackageTypesList.data) || [];
    const boolNumberCodes = useSelector((state: RootStoreType) => state.constantsCodes.data.boolNumberCodes);

    const permissionCreate = useCheckPermission('TRANSPORT_PACKAGE_TYPE.CREATE');
    const permissionDetail = useCheckPermission('TRANSPORT_PACKAGE_TYPE.DETAIL');
    const permissionSync = useCheckPermission('TRANSPORT_PACKAGE_TYPE.SYNC');

    useEffect(() => {
        dispatch(setLocationParams({ name: translate('transportPackageTypes.title') }));
        dispatch(getTransportPackageTypesListFetch());
    }, []);

    return (
        <div data-testid="transport-package-types-list">
            <TopBlock
                reloadList={() => dispatch(getTransportPackageTypesListFetch())}
                syncGeis={() => dispatch(syncTransportPackageTypesFetch())}
                syncCatalogue={() => dispatch(syncCatalogueTransportPackageTypesFetch())}
                permissionCreate={permissionCreate}
                permissionSync={permissionSync}
            />
            <TableSimple
                rowIdKey="SSRC_CODE"
                rows={rows}
                loading={loading}
                columsLabelPrefix="transportPackageTypes.table"
                allColumns={allColumns}
                initSort={{ column: 'SORT_ORDER', direction: 'ASC' }}
                fullHeight
                heightVariant="top-tab-2"
                selectOptions={{ boolNumberCodes }}
                rowActions={[
                    {
                        icon: <StoreIcon />,
                        label: translate('transportPackageTypes.action.detail'),
                        getLink: (row) => `/transports/package-types/${row.SSRC_CODE}/`,
                        hiddenFce: () => !permissionDetail,
                    },
                ]}
            />
        </div>
    );
};

export default TransportPackageTypesListContainer;
